if (!customElements.get('campaign-sets')) {
  customElements.define('campaign-sets', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-set]')];
      if (!this.items.length) return;
      this.category = '';
      this.budget = 'all';
      this.abort = new AbortController();
      this.querySelector('[data-filters]').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-category')) this.category = button.dataset.category;
        else if (button.hasAttribute('data-budget')) this.budget = button.dataset.budget;
        else if (button.hasAttribute('data-reset')) {
          this.category = '';
          this.budget = 'all';
          this.querySelector('button[data-category]').focus();
        } else return;
        this.filter();
      }, { signal: this.abort.signal });
      this.filter();
    }
    filter() {
      let count = 0;
      this.items.forEach(item => {
        const price = Number(item.dataset.price);
        const budgetMatches = this.budget === 'all' ||
          (this.budget === 'low' && price <= 12000) ||
          (this.budget === 'mid' && price > 12000 && price <= 18000) ||
          (this.budget === 'high' && price > 18000);
        item.hidden = !((!this.category || item.dataset.category === this.category) && budgetMatches);
        if (!item.hidden) count++;
      });
      this.querySelectorAll('button[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
      this.querySelectorAll('button[data-budget]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.budget === this.budget)));
      this.querySelector('[data-count]').textContent = count;
      this.querySelector('[data-empty]').hidden = count !== 0;
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
